<template>
  <div v-if="hasBookingTerm">
    <div
      class="box is-blue is-solid px-6 py-4 flex items-center mt-6"
      @click="onClickMobile"
    >
      <svg class="icon-booking" fill="currentColor" width="24" height="24" v-if="bookingTerm.type === 'flexible'">
        <use xlink:href="/img/sprite.svg#ic_booking-hollow" />
      </svg>
      <svg class="icon-booking" fill="currentColor" width="24" height="24" v-if="bookingTerm.type === 'super_flexible'">
        <use xlink:href="/img/sprite.svg#ic_booking-solid" />
      </svg>
      <span class="flex-1 fs-14 ml-2 font-medium">{{ bookingTerm.title }} booking terms</span>
      <a
        href="#"
        class="flex item-centers"
        @click.prevent.stop="$refs.bookingTermModal.show()"
      >
        <svg width="20" height="20" fill="currentColor"><use xlink:href="/img/sprite.svg#ic_question" /></svg>
        <span class="fs-14 ml-1 underline sm:hidden">Learn more</span>
      </a>
    </div>

    <zb-modal
      no-padding
      ref="bookingTermModal"
      class="slide-in-modal booking-term-modal"
      v-if="hasBookingTerm"
    >
      <template v-slot:title>
        <div class="font-medium text-base flex items-center">
          <svg class="icon-booking" fill="currentColor" width="24" height="24" v-if="bookingTerm.type === 'flexible'">
            <use xlink:href="/img/sprite.svg#ic_booking-hollow" />
          </svg>
          <svg class="icon-booking" fill="currentColor" width="24" height="24" v-if="bookingTerm.type === 'super_flexible'">
            <use xlink:href="/img/sprite.svg#ic_booking-solid" />
          </svg>
          {{ bookingTerm.title }} booking terms
        </div>
      </template>
      <template v-slot:default>
        <div
          v-html="bookingTermDescription"
          class="p-6 booking-term-modal-body"
        />
      </template>
    </zb-modal>
  </div>
</template>

<script>
export default {
  name: 'BookingTermPanel',
  props: ['resortId'],
  data() {
    return {
      supplier: {}
    }
  },
  computed: {
    bookingTerm() {
      return typeof this.supplier.booking_term === 'object' ? this.supplier.booking_term : {}
    },
    hasBookingTerm() {
      return typeof this.supplier.booking_term === 'object'
    },
    bookingTermDescription() {
      return this.supplier.cancelation_policy || this.bookingTerm.description
    }
  },
  methods: {
    onClickMobile() {
      if (window.innerWidth <= 1024) {
        this.$refs.bookingTermModal.show()
      }
    }
  },
  mounted () {
    window.fetchSupplierInfo(this.resortId)
      .then(response => {
        this.supplier = response.supplier
      })
      .catch(() => {
        this.supplier = {}
      })
  },
}
</script>

<style lang="scss" scoped>
.icon-booking {
  color: var(--blue)
}

.booking-term-modal {
  &-body {
    ol,
    ul {
      list-style: initial;
      margin-block-start: 1em;
      padding-inline-start: 40px;

      li {
        margin-bottom: 0.5rem;
      }
    }

    ol {
      list-style-type: decimal;
    }
  }

  .zb-modal-title-container {
    border-radius: 4px;
    padding: 0.5rem 1rem;
    background: var(--blue-light-3);

    .zb-modal-close {
      padding: 0;
    }
  }
}
</style>
